// @flow
import * as React from 'react';
import TextWithEllipsis, { TextWithEllipsisFileExtension } from '../common/TextWithEllipsis';
import Span from '../common/elements/Span';
import SmartRangeInput from '../common/SmartRangeInput';
import Center from '../common/layout/Center';
import MultipageControls from '../common/MultipageControls';
import Button from '../common/Button';
import t from '../i18n/I18n';
import './Toolbar.css';
import ViewUtil from '../ViewUtil';
import { ThemeSetup } from '../themes/ThemeSetup';

type Props = {
  names: string[],
  revNums: number[],
  isVideo: boolean,
  syncVideos: boolean,
  onTextClick: Function,
  onRectClick: Function,
  onCircleClick: Function,
  onLineClick: Function,
  onSyncVideoClick: Function,
  onExitClick: Function,
  onCopyCommentsLtoRClick: Function,
  onCopyCommentsRtoLClick: Function,
  disableCopyLtoR: boolean,
  disableCopyRtoL: boolean,
  range: Object,
  scale: number,
  baseline: number,
  onScaleChange: Function,
  multipageProps: {
    current: number,
    total: number,
    onChange: Function
  }
};

export default class Toolbar extends React.Component<Props, {}> {
  _rightName: ?HTMLDivElement;

  componentDidMount() {
    this.forceUpdate();

    const node = this._rightName.parentElement;
    const width = node.getBoundingClientRect().width;
    if (width > 400) {
      node.style.left = '38%';
    } else if (width > 370) {
      node.style.left = '40%';
    } else if (width > 320) {
      node.style.left = '45%';
    }
  }

  render() {
    const {
      isVideo,
      scale,
      baseline,
      range,
      disableCopyLtoR,
      disableCopyRtoL,
      names,
      revNums,
      onCopyCommentsLtoRClick,
      onCopyCommentsRtoLClick,
      onSyncVideoClick,
      syncVideos,
      onExitClick,
      onScaleChange,
      multipageProps,
      is3DAsset
    } = this.props;
    const isAssetTabActive = ViewUtil.isAssetTabActive();
    return (
      <div className={isVideo ? 'video' : ''} name="CompareToolbar">
        <div className="left" style={{ flexBasis: '25%' }}>
          <Center>
            <div className="align-center left-grid">
              <TextWithEllipsisFileExtension
                text={names[0]}
                title={names[0]}
                style={{ maxWidth: window.innerWidth / 3 - 100, height: '19px' }}
                responsive={false}
              />
              <Span className="rev-num" title={t('REVISION') + ` #${revNums[0]}`}>
                {': #' + revNums[0]}
              </Span>
            </div>
          </Center>
        </div>
        <div className="center" style={{ flexBasis: '45%' }}>
          <Center>
            <div className="flex-row align-center">
              {!isAssetTabActive ? (
                disableCopyLtoR ? (
                  <div className="flex-row justify-center" style={{ width: 65 }}>
                    <img src={ThemeSetup.getImageURL('RingSpinner.svg')} style={{ width: 20, height: 20 }} />
                  </div>
                ) : (
                  <label style={{ fontSize: '18px', cursor: 'pointer' }} onClick={onCopyCommentsLtoRClick}>
                    <Span
                      className="fa fa-comments-o"
                      style={{ color: 'var(--primary-style-color)', fontSiz: '15px' }}
                      title={t('COPY_REVISION_COMMENT_TO_RIGHT')}>
                      <span className="fa fa-arrow-right" aria-hidden="true" />
                    </Span>
                  </label>
                )
              ) : null}
              {multipageProps.isMultiPage ? (
                <div className="multipage">
                  <MultipageControls {...multipageProps} />
                </div>
              ) : null}
              {is3DAsset ? null : isVideo ? (
                <label className="simultaneous-play" style={{ fontSize: '14px' }}>
                  <input type="checkbox" name="playBoth" checked={syncVideos} onChange={onSyncVideoClick} />
                  <span>{t('COMPARE_VIEW.SIMULTANEOUS_PLAY')}</span>
                </label>
              ) : (
                <SmartRangeInput
                  value={scale}
                  baseline={baseline}
                  min={range.min}
                  max={range.max}
                  onChange={onScaleChange}
                />
              )}
              {!isAssetTabActive ? (
                disableCopyRtoL ? (
                  <div className="flex-row justify-center" style={{ width: 65 }}>
                    <img src={ThemeSetup.getImageURL('RingSpinner.svg')} style={{ width: 20, height: 20 }} />
                  </div>
                ) : (
                  <label style={{ fontSize: '18px', cursor: 'pointer' }} onClick={onCopyCommentsRtoLClick}>
                    <Span
                      className="fa fa-arrow-left"
                      style={{ color: 'var(--primary-style-color)', fontSiz: '15px' }}
                      title={t('COPY_REVISION_COMMENT_TO_LEFT')}>
                      <span className="fa fa-comments-o" aria-hidden="true" />
                    </Span>
                  </label>
                )
              ) : null}
            </div>
          </Center>
        </div>
        <div className="right" style={{ flexBasis: '30%' }}>
          <div style={{ display: '', width: '100%' }}>
            {/* <Center> */}
            <div
              className="align-center flex-main right-grid"
              style={{ maxWidth: window.innerWidth / 3 - 165, paddingRight: '10px', float: 'left' }}
              ref={(node) => (this._rightName = node)}>
              <Span className="current-revision" title={t('CURRENT_REVISION')} />
              <TextWithEllipsisFileExtension
                title={names[1]}
                text={names[1]}
                responsive={false}
                style={{ height: '19px' }}
              />
              <Span className="rev-num" title={t('REVISION') + ' #' + revNums[1]}>
                {': #' + revNums[1]}
              </Span>
            </div>
            {/* </Center> */}
            <div style={{ float: 'right' }}>
              <Button type="link" onClick={onExitClick}>
                {t('COMPARE_VIEW.EXIT_COMPARE')}
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
